import { IS_WEB } from '../config/index'

export function createCookie (name, value, days, domain) {
  if (!IS_WEB) {
    return
  }
  var expires = ''
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie =
    name + '=' + value + expires + (domain && '; domain=' + domain) + '; path=/'
  return document.cookie
}

export function readCookie (name) {
  if (!IS_WEB) {
    return null
  }
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function eraseCookie (name) {
  createCookie(name, '', -1)
}



// WEBPACK FOOTER //
// ./frontend/scripts/utils/cookies.js